import React, { useState, useEffect } from "react";

import cup from "../../../../../../../../assets/images/cup 2.png";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import EnterImage from "../../../../../../../../assets/images/unsplash_hUHzaiAHuUc.png";
import EventsNav from "./EventsNav";
import { Markup } from "interweave";
import axios from "axios";
import { serverInfo } from "../../../../../../../../App";
import { useContext } from "react";

const StarPromoFeedback = () => {
  const { imageCdnUrl } = useContext(serverInfo);
  const [events, setEvents] = useState([]);

  useEffect(() => {
    axios.get("/api/audition-admin/audition/request").then((res) => {
      if (res.data.status === 200) {
        setEvents(res.data.event);
      }
    });
  }, []);

  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <>
      <div className="AS">
        <div className="card card-bg head-line mb-2 mb-2">
          <div className="text-light d-flex p-2">
            <div className="faTrophy">
              <img src={cup} alt="" width="30px" />
            </div>
            <h4 className="mx-3 text-white p-2">Auditions</h4>
          </div>
        </div>

        <div className="card card-bg mt-3 py-2">
          <div className="">
            <div className="slick-parent d-flex justify-content-center">
              <Slider className="slider-width" {...settings}>
                {events.map((event, index) => (
                  <div key={index} className="p-3">
                    <div className="card bg-dark completedMeetupBlack BlueBorder">
                      <img
                        src={
                          event.banner
                            ? imageCdnUrl+event.banner
                            : EnterImage
                        }
                        className="img-fluid p-2 ImgBlue"
                        alt=""
                        style={{
                          height: "200px",
                          width: "300px",
                        }}
                      />
                      <div className="p-3">
                        <center>
                          <h5 className="text-white text-center title-limit">
                            {event.title ?? ""}
                          </h5>
                          <Link
                            to={`/audition-admin/audition/star-promo-send-feedback/${event.slug}`}
                          >
                            <button className="btn BlueBtn w-100">
                              View Star Feedback
                            </button>
                          </Link>
                        </center>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StarPromoFeedback;
